<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BBk8Uq/tc-custom/9781555847470.jpg?1703704412174" alt="This image is the cover for the book Player"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Player
      </h1>
      <p class="bookDescription body article font2">
        <b>The “shrewd, entertainingly dark Hollywood novel” that inspired the award-winning Robert Altman film (<i>The </i><i>New York Times Book Review</i>). </b><br/>  <br/> Hollywood insider Michael Tolkin perfectly skewers the movie-making business through the mind of Griffin Mill, senior vice president of production at a major Hollywood studio. Ruthlessly ambitious, Mill is driven to control the levers of America’s dream-making machinery. He listens to writers pitch him stories all day, sitting in judgment of their fantasies, their lives. But now one writer whose pitch he responded to so glibly is sending him mortally threatening postcards.<br/>  <br/> Squeezed between the threat to his life and the threat to his job, Mill’s deliberate and horrifying response spins him into a nightmare. Then he meets the sad and beautiful June Mercator and his obsession for her threatens to destroy them both.<br/>  <br/> “One of the most wounding and satirical of all Hollywood exposes.” —<i>Los Angeles Times</i><br/>  <br/> “In its wry, acerbic description of life behind the studio gates Tolkin’s book recalls F. Scott Fitzgerald . . . and the vengeful comedy of Nathaniel West’s <i>The Day of the Locust</i>.” —<i>The Philadelphia Inquirer</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Tolkin
      </h2>
      
      <p class="authorDescription body article">Michael Tolkin is an award-winning writer, director, and producer. His novels include <I>The Player</I>, <I>The Return of the Player</I>, <I>Among the Dead</I>, and <I>Under Radar</I>.   For the film adaptation of <I>The Player</I>, Tolkin won the Writers Guild Award, the BAFTA Award for Best Adapted Screenplay, the PEN Center USA West Literary Award, and the Edgar Allan Poe Award for Best Crime Screenplay. Most recently, he has been a consulting producer and writer for the Showtime series <I>Ray Donovan</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0eb6829a